import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import jwtDecode from 'jwt-decode';
import { SocialService } from './social.service';
import { AuthEventsEmitter } from '../events/auth.events';
import { SocialProviders } from '../enums/socialProviders';
import { Constants } from '../config/constants.config';
import { StorageService } from './storage.service';
import { AppLoadingEventsEmitter } from '../events/loading.events';
import { NotificationsService } from './notification.service';
import { LocalisationService } from './localisation.service';
var AuthService = /** @class */ (function () {
    function AuthService(socialService, authEventsEmitter, httpClient, constants, storageService, router, appIsLoadingEventsEmitter, notificationService, localisationService) {
        var _this = this;
        this.socialService = socialService;
        this.authEventsEmitter = authEventsEmitter;
        this.httpClient = httpClient;
        this.constants = constants;
        this.storageService = storageService;
        this.router = router;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.JWT_KEY = 'JWT_KEY';
        this.token = this.getJWT();
        this.userHasLoggedIn = !!this.token || this.socialService.userIsLoggedInFacebook;
        this.authEventsEmitter.tokenChanged$.subscribe(function (token) {
            _this.token = token;
            _this.userHasLoggedIn = !!_this.token || _this.socialService.userIsLoggedInFacebook;
            if (token) {
                _this.setJWT(token);
            }
            else {
                _this.deleteJWT();
            }
        });
    }
    AuthService.prototype.login = function (email, password) {
        var _this = this;
        return this.httpClient
            .post(this.constants.apiURL() + "/authorize/login/", {
            email: email,
            password: password
        })
            .pipe(map(function (_a) {
            var token = _a.token;
            _this.authEventsEmitter.broadcastTokenChanged(token);
            return { token: token };
        }));
    };
    AuthService.prototype.facebookLogin = function (email, first_name, last_name, account_id, locale, referral) {
        var _this = this;
        return this.httpClient
            .post(this.constants.apiURL() + "/authorize/facebook/", {
            email: email,
            first_name: first_name,
            last_name: last_name,
            provider: {
                account_id: account_id,
                provider: SocialProviders.Facebook
            },
            locale: locale,
            referral: referral
        })
            .pipe(map(function (_a) {
            var token = _a.token;
            _this.authEventsEmitter.broadcastTokenChanged(token);
            return { token: token };
        }));
    };
    AuthService.prototype.register = function (registerDTO) {
        var _this = this;
        return this.httpClient.post(this.constants.apiURL() + "/authorize/register/", registerDTO).pipe(switchMap(function () {
            return _this.login(registerDTO.email, registerDTO.password);
        }));
    };
    AuthService.prototype.createPasswordResetLink = function (createPasswordResetLinkDTO) {
        return this.httpClient.post(this.constants.apiURL() + "/reset/password/", createPasswordResetLinkDTO);
    };
    AuthService.prototype.resetPassword = function (resetPasswordDTO) {
        return this.httpClient.put(this.constants.apiURL() + "/reset/password/", resetPasswordDTO);
    };
    AuthService.prototype.getJWT = function () {
        return this.storageService.getItem(this.JWT_KEY);
    };
    AuthService.prototype.setJWT = function (jwt) {
        this.storageService.setItem(this.JWT_KEY, jwt);
    };
    AuthService.prototype.deleteJWT = function () {
        this.storageService.removeItem(this.JWT_KEY);
    };
    AuthService.prototype.logout = function () {
        var _this = this;
        this.authEventsEmitter.broadcastTokenChanged(null);
        this.router.navigate(['login']).then(function () {
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    AuthService.prototype.setStorageItem = function (key, value) {
        this.storageService.setItem(key, value);
    };
    AuthService.prototype.getStorageItem = function (key) {
        return this.storageService.getItem(key);
    };
    AuthService.prototype.errorHandler = function () {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        this.logout();
        this.notificationService.error(this.localisationService.localise('server_err_something_went_wrong'));
    };
    Object.defineProperty(AuthService.prototype, "jwtPayload", {
        get: function () {
            if (!this.token) {
                return undefined;
            }
            return jwtDecode(this.token);
        },
        enumerable: true,
        configurable: true
    });
    return AuthService;
}());
export { AuthService };
